import { render, staticRenderFns } from "./status-column.vue?vue&type=template&id=406d2f5b"
import script from "./status-column.vue?vue&type=script&lang=js"
export * from "./status-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('406d2f5b')) {
      api.createRecord('406d2f5b', component.options)
    } else {
      api.reload('406d2f5b', component.options)
    }
    module.hot.accept("./status-column.vue?vue&type=template&id=406d2f5b", function () {
      api.rerender('406d2f5b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/contact/status-column.vue"
export default component.exports